// extracted by mini-css-extract-plugin
export default {"wrapper":"burger-constructor_wrapper__EzFGR","cardsContainer":"burger-constructor_cardsContainer__DjPgJ"};